<mat-form-field class="email-chip" appearance="fill">
  <mat-label class="email-chip__label">{{ 'review_form.email_label' | i18nextEager }}</mat-label>

  <div class="email-chip__grid-container">
    <mat-chip-grid #chipGrid aria-label="Email selection" class="email-chip__grid">
      <div class="email-chip__row-container">
        @for (email of values; track $index) {
          <mat-chip-row class="email-chip__row" (removed)="remove(email.value)" [ngClass]="{ 'email-chip__row--error': !email.valid }">
            {{ email.value }}
            <bdeo-icon matChipRemove name="action-close" size="small" [color]="getIconColor(email)"></bdeo-icon>
          </mat-chip-row>
        }
      </div>

      <input
        class="email-chip__input"
        placeholder="{{ 'review_form.email_placeholder' | i18nextEager }}"
        [matChipInputFor]="chipGrid"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="addOnBlur"
        (matChipInputTokenEnd)="add($event)"
        (input)="$event.stopPropagation()"
      />
    </mat-chip-grid>
  </div>
</mat-form-field>
